import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Generischer Sammel-Link: erzeugt beim Öffnen einen frischen Onboarding-Token
// und leitet auf die normale Onboarding-Seite weiter.
const OnboardingStart = () => {
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    fetch(`${API}/public/onboarding/start`, { method: 'POST' })
      .then(r => r.json())
      .then(d => {
        if (d?.token) navigate(`/onboarding/${d.token}`, { replace: true });
      })
      .catch(() => {});
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  );
};

export default OnboardingStart;
